import React, { useEffect, useRef, useState } from 'react';
import {
  Card,
  Row,
  Col,
  Input,
  Form,
  Select,
  // Checkbox,
  message,
  Space,
  Radio,
  Divider,
  DatePicker,
  TimePicker,
  Tag,
  Alert,
  Typography
} from 'antd';
import Layout from '@/common/Layout';
import styles from '@/common/Layout/index.module.less';
import FormItem from '@/common/FormItem';
import { useDispatch } from 'react-redux';
import {
  getAllEquips,
  // getCurrentProduct,
  createProdClearence,
  getAlllclist,
  createQAClearence,
  initiateQaVerification
} from '../../redux/slice';
import CustomModal from '@/common/CustomModal';
import {
  getProductBatches,
  verifyBatch
} from '@/features/productionLabelGen/redux/slice';
import { useParams } from 'react-router-dom';
import CustomButton from '@/common/CustomButton';
import { getLoggedInUser, getRoles } from 'utilities/helpers';
import moment from 'moment';
import { QrReader } from 'react-qr-reader';
import { useLocation } from 'react-router-dom';
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  QrcodeOutlined
} from '@ant-design/icons';
import VerificationModal from '@/features/material/components/VerificationModal';
import { history } from 'app/history';

const LineClearence = () => {
  const [form] = Form.useForm();
  const params = useParams();
  const { user } = getLoggedInUser();
  const isProdRole = user?.role === 'prod_ebmr' || user?.role === 'prod_user';
  const { SuperadminProddata } = getRoles('Production');
  const { SuperadminQAdata } = getRoles('Quality Assurance');

  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);

  const [allEquips, setAllEquips] = useState([]);
  // const [currentProduct, setCurrentProduct] = useState([]);
  // const [lcMasters, setLcMasters] = useState([]);
  const [inspectionsByProd, setInspectionsByProd] = useState([]);
  const [inspectionsByQA, setInspectionsByQA] = useState([]);
  const [infProd, setInfProd] = useState('');
  const [infQA, setInfQA] = useState('');
  const [lCViewData, setLCViewData] = useState({});
  const [lCQuestions, setLCQuestions] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [data, setData] = useState({});
  const [type, setType] = useState('');
  const [search, setSearch] = useState('');
  const [searchLC, setSearchLC] = useState('');
  const [eqpType, setEqpType] = useState('');
  const [tempLCQtns, setTempLCQtns] = useState([]);
  // QA's justification per checkpoint, keyed by lc_bmr_eqp_question id. Only sent for
  // checkpoints that still disagree at submit time.
  const [overrideReasons, setOverrideReasons] = useState({});
  const [eqpIds, setEqpIds] = useState([]);
  // isCompression now means "WIP-only" (true for both Compression and Inspection)
  // and drives the free-text-batch / no-DR rendering. lcType disambiguates which
  // flag to persist on submit.
  const [isCompression, setIsCompression] = useState('');
  const [lcType, setLcType] = useState('');
  const [productsData, setProductsData] = useState([]);
  const [isEditProduct, setIsEditProduct] = useState(false);
  const [filteredBatch, setFilteredBatch] = useState([]);
  const [eqpIdsData, setEqpIdsData] = useState([]);
  const [processEqpID, setProcessEqpID] = useState('');
  const [otherField, setOtherField] = useState('');
  const [openCam, setOpenCam] = useState(false);
  const [showSubimt, setShowSubimt] = useState(false);
  // const [newCurBatch, setNewCurBatch] = useState('');
  const [allAccessories, setAllAccessories] = useState([
    {
      accessory_name: '',
      accessory_id: '',
      cleaning: '',
      inspect_by_prod: '',
      inspect_by_qa: ''
    }
  ]);

  // PR line clearance initiation. The create form's mount moment is held here and sent
  // only when the form is submitted, so opening the page and walking away writes
  // nothing. performance.now() is monotonic, so a system clock change while the form is
  // open cannot corrupt the elapsed duration.
  const prInitRef = useRef(performance.now());

  // QA verification gate. qaVerificationStarted stays false until the LC record confirms
  // verification has begun, so the QA column is never interactive before the fetch
  // resolves. qaGatePromptedRef keeps the modal to one prompt per mount.
  const [qaVerificationStarted, setQaVerificationStarted] = useState(false);
  const [showQaInitiateModal, setShowQaInitiateModal] = useState(false);
  const [qaInitiating, setQaInitiating] = useState(false);
  const qaGatePromptedRef = useRef(false);

  const dispatch = useDispatch();

  // A QA user viewing an existing, not-yet-approved LC is read-only until they declare
  // they are starting the verification. False for every other role, for approved LCs and
  // in create mode, so every pre-existing path is unchanged.
  const isQaPendingLc =
    user?.role === 'qc_initiator' &&
    !!searchParams.get('id') &&
    lCViewData?.lc_status !== 'Approved';
  const qaViewOnly = isQaPendingLc && !qaVerificationStarted;

  // True while the QA column accepts input - the same condition the QA radios are
  // enabled by. The override prompts only make sense in that state.
  const qaColumnEnabled = !(
    (user?.role == 'qc_initiator'
      ? lCViewData?.qa_sign_date && !isEdit
      : true) || qaViewOnly
  );

  // A checkpoint QA has answered differently to production. A blank on either side is a
  // gap in the record, not a disagreement, so it is not treated as an override - QA
  // answering a checkpoint production left empty is not overriding anything.
  const qaAnswerFor = (question_id) =>
    inspectionsByQA?.filter((data) => data?.question == question_id)?.[0]
      ?.inspect_by_qa;

  const isOverride = (item) => {
    const prod = item?.inspect_by_prod;
    const qa = qaAnswerFor(item?.id);
    return !!prod && !!qa && prod !== qa;
  };

  const overriddenQuestions = () =>
    (lCViewData?.lc_bmr_eqp_questions || []).filter(isOverride);

  // Overrides are captured on the QA verification submit. The post-approval edit path
  // goes through a different branch that does not rewrite the production response, so
  // no prompt is shown there rather than showing one that would not be acted on.
  const overrideCaptureEnabled =
    qaColumnEnabled && !isEdit && !lCViewData?.qa_sign_date;

  const handleOverrideReason = (question_id, value) =>
    setOverrideReasons((prev) => ({ ...prev, [question_id]: value }));

  // Rendered under a checkpoint whose two responses disagree. Approving rewrites
  // inspect_by_prod, so the reason is the only record of what production first recorded.
  const renderOverrideReason = (item) => {
    if (!overrideCaptureEnabled || !isOverride(item)) return null;
    return (
      <Row gutter={24}>
        <Col xs={24} xl={24} span={24}>
          <div style={{ marginBottom: '4px' }}>
            <Typography.Text type="warning">
              {`Production recorded ${item?.inspect_by_prod}. Submitting will override it to match yours - state the reason`}
            </Typography.Text>
          </div>
          <Input.TextArea
            rows={2}
            maxLength={500}
            showCount
            value={overrideReasons?.[item?.id] || ''}
            onChange={(e) => handleOverrideReason(item?.id, e.target.value)}
            placeholder="e.g. residue observed on the gasket during verification"
          />
        </Col>
      </Row>
    );
  };

  const handleInitiateQaVerification = () => {
    setQaInitiating(true);
    dispatch(initiateQaVerification({ id: searchParams.get('id') }))
      .then((res) => {
        if (res?.payload?.success) {
          setQaVerificationStarted(true);
          setShowQaInitiateModal(false);
          message.success(res?.payload?.message);
        } else {
          message.error(
            res?.payload?.message || 'Unable to initiate LC verification.'
          );
        }
      })
      .finally(() => setQaInitiating(false));
  };

  useEffect(() => {
    // handleGetAllEquipements();
    // handleGetCurrentProduct();
    handleGetProductBatches();
    searchParams.get('id') ? handleGetAllLCList() : '';
  }, [search]);

  useEffect(() => {
    handleGetAllEquipements();
  }, [searchLC]);

  const handleGetAllLCList = () => {
    let payload = { id: searchParams.get('id') };
    dispatch(getAlllclist(payload)).then((res) => {
      if (res?.payload?.success) {
        // Decide the QA gate here rather than on mount: the answer depends on
        // lc_status and qa_verification_initiated_at, which only arrive with the LC.
        const already_initiated =
          !!res?.payload?.data?.qa_verification_initiated_at;
        setQaVerificationStarted(already_initiated);
        if (
          user?.role === 'qc_initiator' &&
          res?.payload?.data?.lc_status !== 'Approved' &&
          !already_initiated &&
          !qaGatePromptedRef.current
        ) {
          qaGatePromptedRef.current = true;
          setShowQaInitiateModal(true);
        }
        setLCViewData(res?.payload?.data);
        setInfProd(res?.payload?.data?.infer_prod_dept);
        setInfQA(res?.payload?.data?.infer_qa_dept);
        setAllAccessories(res?.payload?.data?.access_clean_verifies);
        // setLCQuestions(res?.payload?.data?.lc_bmr_eqp_questions);
        let questions_temp = res?.payload?.data?.lc_bmr_eqp_questions.filter(
          (qtn) => qtn?.lc_eqp_question_master?.lc_question_type === 'value'
        );
        let questions = res?.payload?.data?.lc_bmr_eqp_questions.filter(
          (qtn) => qtn?.lc_eqp_question_master?.lc_question_type !== 'value'
        );
        res?.payload?.data?.lc_eqp_id === 'Others'
          ? setOtherField(true)
          : setOtherField(false);
        setLCQuestions(questions);
        setTempLCQtns(questions_temp);
        const _lc_type = res?.payload?.data?.is_inspection
          ? 'inspection'
          : res?.payload?.data?.is_compression
          ? 'compression'
          : 'normal';
        setLcType(_lc_type);
        setIsCompression(
          res?.payload?.data?.is_compression === true ||
            res?.payload?.data?.is_inspection === true
        );
        form.setFieldsValue({
          lc_type: _lc_type,
          current_batch: res?.payload?.data?.current_batch,
          current_product: res?.payload?.data?.current_product,
          equipment_name: res?.payload?.data?.eqp_lc_master?.line_clr_eqp_name,
          lc_format_id: res?.payload?.data?.eqp_lc_master?.lc_format,
          eqp_name: res?.payload?.data?.eqp_name,
          equipment_id: res?.payload?.data?.lc_eqp_id,
          previous_product: res?.payload?.data?.previous_product,
          previous_batch: res?.payload?.data?.previous_batch,
          lot_no: res?.payload?.data?.lot_no,
          cleaning_type: res?.payload?.data?.cleaning_type,
          eqp_other_details: res?.payload?.data?.eqp_other_details
        });
        let list = [...inspectionsByProd];
        res?.payload?.data?.lc_bmr_eqp_questions?.map((item) => {
          list.push({
            question: item?.id,
            inspect_by_prod: item?.inspect_by_prod
          });
        });

        setInspectionsByProd(list);
        let qalist = [...inspectionsByQA];
        res?.payload?.data?.lc_bmr_eqp_questions?.map((item) => {
          qalist.push({
            question: item?.id,
            inspect_by_qa: item?.inspect_by_qa
          });
        });

        setInspectionsByQA(qalist);
      }
    });
  };

  const handleGetProductBatches = () => {
    const payload = { search };
    dispatch(getProductBatches(payload)).then((res) => {
      if (res.payload.success) {
        setProductsData(res.payload.data);
        setIsEditProduct(false);
      }
    });
  };

  const handleVerify = () => {
    const payload = {
      product_batch: form.getFieldValue('current_product')
    };
    dispatch(verifyBatch(payload)).then((res) => {
      if (res?.payload?.success) {
        message.success(res?.payload?.message);
        setShowSubimt(true);
      } else {
        message.error(res?.payload?.message);
        setShowSubimt(false);
      }
    });
  };

  const handleUpdate = () => {
    const payload = {
      id: searchParams.get('id'),
      current_product: form.getFieldValue('current_product'),
      current_batch: form.getFieldValue('current_batch')
    };
    setType('QAUPDATE');
    setData(payload);
    setIsModal(!isModal);
  };
  const handleGetAllEquipements = () => {
    const payload = { searchLC };
    dispatch(getAllEquips(payload)).then((res) => {
      if (res?.payload?.success) {
        setAllEquips(res?.payload?.data);
      }
    });
  };

  const onSearch = (value) => {
    console.log(value?.length);
    value?.length > 3 ? setSearch(value) : '';
  };

  const onSearchLCForm = (value) => {
    setSearchLC(value);
  };
  // const handleGetCurrentProduct = () => {
  //   const payload = { dispensing_request_id: params?.id };
  //   dispatch(getCurrentProduct(payload)).then((res) => {
  //     if (res?.payload?.success) {
  //       setCurrentProduct(res?.payload?.data);
  //     }
  //   });
  // };

  const onChange = (e) => {
    const product_name = productsData?.filter((product) => product.id === e);
    const payload = { search: product_name?.[0]?.product_batch_number };
    dispatch(getProductBatches(payload)).then((res) => {
      if (res.payload.success) {
        // const eqp_data = [];
        console.log(
          res?.payload?.data?.filter((data) => data?.id === e),
          'filterData'
        );
        // res?.payload?.data?.map((data) => {
        //   eqp_data.push(data?.product_detail?.process_eqp_ids);
        // });
        // let merge_data = [];
        // for (const eq of eqp_data) {
        //   merge_data = [...merge_data, ...eq];
        // }
        // console.log(merge_data, 'eqp_data');
        setEqpIdsData(
          res?.payload?.data?.filter((data) => data?.id === e)?.length
            ? res?.payload?.data?.filter((data) => data?.id === e)?.[0]
                ?.product_detail?.process_eqp_ids
            : []
        );
      }
    });

    console.log(product_name);
    setFilteredBatch(product_name);
    form?.setFieldsValue({
      current_product: product_name?.[0]?.product_detail?.name
    });
  };

  const handleOnChange = (e) => {
    const eqp_id = allEquips.filter((data) => data?.id == e);
    console.log(eqp_id);
    setEqpType(eqp_id?.[0]?.lc_type);
    let questions = eqp_id?.[0]?.lc_eqp_question_masters.filter(
      (qtn) => qtn?.lc_question_type !== 'value'
    );
    let questions_temp = eqp_id?.[0]?.lc_eqp_question_masters.filter(
      (qtn) => qtn?.lc_question_type === 'value'
    );
    console.log(questions);
    // setLcMasters(eqp_id);
    setLCQuestions(questions);
    setTempLCQtns(questions_temp);
    setEqpIds(eqp_id);
    //reset lc_format_id to empty
    form.setFieldsValue({ lc_format_id: '' });
  };

  console.log(form.validateFields, 'validfields ========');

  useEffect(() => {
    form.setFieldsValue({
      equipment_name: lCViewData?.eqp_lc_master?.id,
      equipment_id: lCViewData?.eqp_id_lc_master?.lc_eqp_id,
      previous_product: lCViewData?.previous_product,
      previous_batch: lCViewData?.previous_batch
    });
  }, []);

  const handleOnChangeProd = (id, e, type) => {
    var empData = inspectionsByProd.find((value) => value.question === id);
    console.log(empData);
    if (empData) {
      if (type == 'prod') {
        let list = [...inspectionsByProd];
        list.find((value) => value.question === id).inspect_by_prod = e;
        setInspectionsByProd(list);
      } else {
        let list = [...inspectionsByQA];
        list.find((value) => value.question === id).inspect_by_qa = e;
        setInspectionsByQA(list);
      }
    } else {
      let list = [...inspectionsByProd];
      list.push({ question: id, inspect_by_prod: e });
      setInspectionsByProd(list);
    }
  };
  console.log(lCQuestions, filteredBatch);
  const handleOnChangeInfProd = (e, type) => {
    type == 'QA' ? setInfQA(e) : setInfProd(e);
  };

  // const handleChangeBatch = (e) => {
  //   console.log(e.target.value);
  //   setNewCurBatch(e.target.value);
  // };
  const onChangeLabel = (value) => {
    form.resetFields();
    form.setFieldsValue({ lc_type: value });
    setLcType(value);
    // Compression and Inspection are both WIP-only (no DR, free-text batch).
    setIsCompression(value !== 'normal');
    setShowSubimt(false);
  };

  const handleOnChangeEqp = (e) => {
    if (e === 'others') {
      setOtherField(true);
    } else {
      const filtered_data = eqpIdsData?.filter(
        (data) => data?.equipment_model_id === e
      );
      setOtherField(false);
      setProcessEqpID(filtered_data?.[0]?.id);
    }
  };
  const onFinish = (values) => {
    if (searchParams.get('id') && isProdRole) {
      values.id = searchParams.get('id');
      values.infer_prod_dept = infProd;
      values.questions = inspectionsByProd;
      values.accessory_verify = allAccessories.length ? allAccessories : [];
      values.dispensing_request_id = params.id;
      values.is_compression = lcType === 'compression';
      values.is_inspection = lcType === 'inspection';
      values.process_eqpid_id = processEqpID;
      // values.current_batch =
      // values.is_compression === 'yes'
      //   ? values.current_batch
      //   : filteredBatch[0]?.product_batch_number;
      setData(values);
      setIsModal(!isModal);
      setType('prod_ebmr');
    } else if (
      searchParams.get('id') &&
      user?.role == 'qc_initiator' &&
      // user?.level == 2
      lCViewData?.qa_sign_date
    ) {
      console.log(allAccessories.length, 'access');
      values.id = searchParams.get('id');
      values.infer_qa_dept = infQA;
      values.questions = inspectionsByQA;
      values.accessory_verify = allAccessories.length ? allAccessories : [];
      values.dispensing_request_id = params.id;
      values.isType = 'Edit';
      values.is_compression = lcType === 'compression';
      values.is_inspection = lcType === 'inspection';
      values.process_eqpid_id = processEqpID;

      setType('QA');
      setData(values);
      setIsModal(!isModal);
    } else if (searchParams.get('id') && user?.role == 'qc_initiator') {
      /* Approving rewrites the production response on any checkpoint the two disagree
         on, so every difference has to carry a reason. Recomputed here rather than read
         off state written earlier, since a reason typed and then reverted is stale. */
      const overridden = overriddenQuestions();
      const unexplained = overridden.filter(
        (item) => !(overrideReasons?.[item?.id] || '').trim()
      );
      if (unexplained.length > 0) {
        message.error(
          'Please state a reason for each response that differs from the Production response'
        );
        return;
      }

      values.id = searchParams.get('id');
      values.infer_qa_dept = infQA;
      values.questions = inspectionsByQA;
      values.accessory_verify = allAccessories.length ? allAccessories : [];
      values.dispensing_request_id = params.id;
      values.overrides = overridden.map((item) => ({
        checklist_id: item?.id,
        reason: (overrideReasons?.[item?.id] || '').trim()
      }));
      dispatch(createQAClearence(values)).then((res) => {
        if (res?.payload?.success) {
          message.success(res?.payload?.message);
          // history.push(`/qa-lc-list/${params.id}`);
          history.push(`/qa-lc-list`);
        }
      });
    } else {
      // values.current_product = currentProduct?.product_detail?.name;
      // values.current_batch = currentProduct?.product_batch_number;
      values.infer_prod_dept = infProd;
      // values.infer_qa_dept = '';
      values.questions = inspectionsByProd;
      values.accessory_verify = allAccessories.length ? allAccessories : [];
      values.dispensing_request_id = params.id;
      values.is_compression = lcType === 'compression';
      values.is_inspection = lcType === 'inspection';
      values.process_eqpid_id = processEqpID;
      // Elapsed time since the create form mounted. The server subtracts it from its own
      // clock, so the stored initiation moment can never post-date the submission.
      values.pr_initiated_elapsed_ms = Math.round(
        performance.now() - prInitRef.current
      );
      // values.current_batch = values.is_compression
      //   ? values.current_batch
      //   : filteredBatch[0]?.product_batch_number;
      dispatch(createProdClearence(values)).then((res) => {
        if (res?.payload?.success) {
          message.success(res?.payload?.message);
          history.push(`/qa-lc-list`);
        }
      });
    }
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      const scannedValue = scanData.text.slice(
        scanData.text.lastIndexOf('/') + 1
      );

      form.setFieldsValue({
        eqp_other_details: scannedValue
      });
      setOpenCam(false);
    }
  };

  const handleChangeDoneDate = (e, id, index, type, prop) => {
    console.log(e, id, index, type, prop);

    var empData = inspectionsByProd.find((value) => value.question === id);
    console.log(empData);
    if (empData) {
      if (type == 'prod') {
        let list = [...inspectionsByProd];
        list.find((value) => value.question === id)[prop] =
          prop === 'date_time'
            ? `${moment(e).format('hh:mm')}`
            : prop === 'observed_value'
            ? e.target.value
            : `${moment(e).format('YYYY-MM-DD')}`;
        setInspectionsByProd(list);
      } else {
        let list = [...inspectionsByQA];
        list.find((value) => value.question === id)[prop] =
          prop === 'date_time'
            ? `${moment(e).format('hh:mm')}`
            : prop === 'observed_value'
            ? e.target.value
            : `${moment(e).format('YYYY-MM-DD')}`;
        setInspectionsByQA(list);
      }
    } else {
      let list = [...inspectionsByProd];
      list.push({
        question: id,
        inspect_by_prod: '',
        [prop]:
          prop === 'date_time'
            ? `${moment(e).format('hh:mm')}`
            : prop === 'observed_value'
            ? e.target.value
            : `${moment(e).format('YYYY-MM-DD')}`
      });
      setInspectionsByProd(list);
    }
  };

  const handleAddAccessories = () => {
    setAllAccessories([
      ...allAccessories,
      {
        accessory_name: '',
        accessory_id: '',
        cleaning: '',
        inspect_by_prod: '',
        inspect_by_qa: ''
      }
    ]);
  };
  const handleOnchangeAccessory = (e, index, type) => {
    // if (main_type == 'prod') {
    let list = [...allAccessories];
    list[index][type] = e;
    setAllAccessories(list);
    // } else {
    //   let list = [...allAccessories];
    //   list[index][type] = e;
    //   setAllAccessories(list);
    // }
  };
  console.log(allAccessories);
  const handleDeleteAccessories = (index) => {
    let list = [...allAccessories];
    list.splice(index, 1);
    setAllAccessories(list);
  };
  console.log(inspectionsByProd);
  return (
    <Layout sider={false}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Space direction="vertical">
          <Card
            className={`${styles.cardStyles_approver}`}
            title={<span style={{ fontWeight: 'bold' }}>Product Details</span>}
            extra={
              qaViewOnly ? (
                <Space>
                  <Tag color="#ff9933">View only</Tag>
                  <CustomButton
                    type="primary"
                    size="small"
                    loading={qaInitiating}
                    onClick={handleInitiateQaVerification}
                  >
                    Initiate LC Verification
                  </CustomButton>
                </Space>
              ) : (
                ''
              )
            }
            // extra={
            //   user?.role === 'qc_initiator' && user?.level == 2 && lCViewData?.lc_status !== 'Approved' ? (
            //     <EditOutlined onClick={() => setIsEditProduct(true)} />
            //   ) : (
            //     ''
            //   )
            // }
          >
            <Row gutter={24}>
              <Col span={8}>
                <FormItem
                  label="LC Type"
                  name="lc_type"
                  rules={[
                    {
                      required: true,
                      message: 'Select LC type'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select LC type"
                    onChange={onChangeLabel}
                    disabled={searchParams.get('id')}
                  >
                    <Select.Option value="normal">Others</Select.Option>
                    <Select.Option value="compression">
                      Compression
                    </Select.Option>
                    <Select.Option value="inspection">Inspection</Select.Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              {isCompression === false ? (
                <>
                  <Col span={8}>
                    <FormItem
                      label="Clearence for Batch #"
                      name="current_batch"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select Product Batch"
                        showSearch
                        optionFilterProp="children"
                        onChange={onChange}
                        onSearch={onSearch}
                        disabled={searchParams.get('id')}
                      >
                        {productsData?.map((category, index) => {
                          const processName =
                            category?.prod_label_process_master
                              ?.process_label_name;
                          const subProcessName =
                            category?.prod_label_sub_process?.sub_process_name;
                          return (
                            <option value={category?.id} key={index}>
                              {category?.product_batch_number}
                              {processName ? ` - ${processName}` : ''}
                              {subProcessName ? ` › ${subProcessName}` : ''}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span={16}>
                    <FormItem
                      label="Current Product Name"
                      name="current_product"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder=""
                        value=""
                        // disabled={params.get('id') ? dataId : data}
                        disabled
                      />
                    </FormItem>
                  </Col>
                </>
              ) : (
                isCompression === true && (
                  <>
                    <Col span={8}>
                      <FormItem
                        label="Clearence for Batch #"
                        name="current_batch"
                        rules={[
                          {
                            required: true,
                            message: 'Select Product Batch'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder=""
                          // onChange={handleChangeBatch}
                          disabled={
                            (user?.role === 'qc_initiator' && !isEditProduct) ||
                            (searchParams.get('id') && isProdRole)
                          }
                          // disabled={searchParams.get('id')}
                        />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        label="Current Product Name"
                        name="current_product"
                        rules={[
                          {
                            required: true,
                            message: 'Select Product name'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder=""
                          value=""
                          disabled={
                            (user?.role === 'qc_initiator' && !isEditProduct) ||
                            (searchParams.get('id') && isProdRole)
                          }
                          // disabled
                        />
                      </FormItem>
                    </Col>

                    <Col span={4}>
                      {user?.role === 'qc_initiator' && isEditProduct ? (
                        <CustomButton
                          type="primary"
                          onClick={handleUpdate}
                          // disabled={searchParams.get('id')}
                          className={styles.buttons}
                        >
                          Update
                        </CustomButton>
                      ) : searchParams.get('id') ? (
                        ''
                      ) : (
                        <CustomButton
                          type="primary"
                          onClick={handleVerify}
                          // disabled={searchParams.get('id')}
                          className={styles.buttons}
                        >
                          Verify Batch
                        </CustomButton>
                      )}
                    </Col>
                  </>
                )
              )}
            </Row>
          </Card>
          <Card
            className={`${styles.cardStyles_approver}`}
            title={
              <span style={{ fontWeight: 'bold' }}>
                Line Clearence Check List
              </span>
            }
            extra={
              searchParams.get('id') ? (
                (isProdRole &&
                  user?.level == 3 &&
                  lCViewData?.lc_status !== 'Approved') ||
                // (user?.role === 'qc_initiator' && user?.level == 3) ||
                SuperadminQAdata?.[0]?.level == 2 ||
                SuperadminProddata?.[0]?.level == 3 ? (
                  <EditOutlined onClick={() => setIsEdit(true)} />
                ) : (
                  ''
                )
              ) : (
                ''
              )
            }
          >
            <Row gutter={24}>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Line clearance form name"
                  name="equipment_name"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearchLCForm}
                    placeholder="Select Lineclearance form"
                    onChange={(e) => handleOnChange(e)}
                    disabled={searchParams.get('id') ? true : false}
                  >
                    {allEquips?.map((item, index) => {
                      return (
                        <option value={item?.id} key={index}>
                          {item?.line_clr_eqp_name || 'jjjj'}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="LC format #"
                  name="lc_format_id"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  {/* <Input placeholder="Enter LC format ID" /> */}
                  <Select
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearch}
                    placeholder="Select LC format ID"
                    // onChange={(e) => handleOnChange(e)}
                    disabled={searchParams.get('id') ? true : false}
                  >
                    {eqpIds?.map((item, index) => {
                      return (
                        <option value={item?.lc_format} key={index}>
                          {item?.lc_format}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Equipment/Area name"
                  name="eqp_name"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder="Enter Equipment / Area"
                    disabled={searchParams.get('id') ? true : false}
                    // value={currentProduct?.product_detail?.name}
                    // disabled
                  />
                  {/* <Select
                    placeholder="Select a Equipment / Area"
                    disabled={searchParams.get('id') ? true : false}
                  >
                    {lcMasters?.[0]?.eqp_id_lc_masters?.map((item, index) => {
                      return (
                        <option value={item?.id} key={index}>
                          {item?.lc_eqp_id}
                        </option>
                      );
                    })}
                  </Select> */}
                </FormItem>
              </Col>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Equipment Id"
                  name="equipment_id"
                  rules={[
                    {
                      required: false,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearch}
                    placeholder="Select Equipment ID"
                    onChange={(e) => handleOnChangeEqp(e)}
                    disabled={searchParams.get('id') ? true : false}
                  >
                    <option value="others">Others</option>
                    {eqpIdsData?.map((item, index) => {
                      return (
                        <option value={item?.equipment_model?.id} key={index}>
                          {item?.equipment_model?.equipment_id}
                        </option>
                      );
                    })}
                  </Select>
                  {/* <Input
                    placeholder="Enter Equipment Id"
                    disabled={searchParams.get('id') ? true : false}
                  /> */}
                </FormItem>
              </Col>
              {otherField && (
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Other Equipment ID"
                    name="eqp_other_details"
                    rules={[
                      {
                        required: false,
                        message: 'Material Code'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    {/* <Space style={{ width: '100%' }}> */}
                    {/* <CustomButton className={styles.qrcode}>
                        <QrcodeOutlined onClick={() => setOpenCam(true)} />
                      </CustomButton> */}
                    <Input
                      placeholder="Enter Equipment Other Details"
                      // disabled={searchParams.get('id') ? true : false}
                      disabled
                      addonBefore={
                        <CustomButton
                          disabled={isProdRole ? searchParams.get('id') : true}
                          // className={styles.qrcode}
                          onClick={() => setOpenCam(true)}
                          style={{ border: 'none', background: 'transparent' }}
                        >
                          <QrcodeOutlined />
                        </CustomButton>
                      }
                    />
                    {/* </Space> */}
                  </FormItem>
                </Col>
              )}
              {/* <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Current Product Name"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder="Enter Current product Name"
                    // value={currentProduct?.product_detail?.name}
                    disabled
                  />
                </FormItem>
              </Col>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Clearence for Batch #"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder="Enter Clearence for Batch #"
                    // value={currentProduct?.product_batch_number}
                    disabled
                  />
                </FormItem>
              </Col> */}
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Previous Product Name"
                  name="previous_product"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder="Enter Previous Product Name"
                    disabled={
                      isProdRole ? searchParams.get('id') && !isEdit : true
                    }
                  />
                </FormItem>
              </Col>
              <Col xs={24} xl={12} span={12} md={24} sm={24}>
                <FormItem
                  label="Previous Batch #"
                  name="previous_batch"
                  rules={[
                    {
                      required: true,
                      message: 'Material Code'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder="Enter Previous Batch #"
                    disabled={
                      isProdRole ? searchParams.get('id') && !isEdit : true
                    }
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Lot no"
                  name="lot_no"
                  rules={[
                    {
                      required: true,
                      message: 'Select lot no'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Lot number"
                    showSearch
                    disabled={
                      isProdRole ? searchParams.get('id') && !isEdit : true
                    }
                  >
                    {Array.from({ length: 10 }, (_, i) => i).map((i) => {
                      return (
                        <option value={i} key={i}>
                          {i == 0 ? 'NA' : `Lot ${i}`}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label="Cleaning type"
                  name="cleaning_type"
                  rules={[
                    {
                      required: true,
                      message: 'Select lot no'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select type"
                    showSearch
                    disabled={
                      isProdRole ? searchParams.get('id') && !isEdit : true
                    }
                  >
                    <option value="Type_A">Type A</option>
                    <option value="Type_C">Type C</option>
                    <option value="General">General</option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </Card>
          {lCQuestions?.length ? (
            <>
              <Card className={`${styles.cardStyles_approver12}`}>
                <Row gutter={24}>
                  <Col xs={24} xl={12} span={12} md={24} sm={24}></Col>
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <b>Inspected By Production</b>
                  </Col>
                  <Col xs={24} xl={6} span={6} md={24} sm={24}>
                    <b>Inspected By QA</b>
                  </Col>
                </Row>
                <br />
                {lCQuestions?.map((item, index) => {
                  return (
                    <>
                      <Row gutter={24} key={index}>
                        <Col xs={24} xl={12} span={12} md={24} sm={24}>
                          <p style={{ color: 'black' }}>
                            {searchParams.get('id')
                              ? item?.lc_eqp_question_master?.lc_eqp_question
                              : item?.lc_eqp_question}
                            {item?.lc_eqp_question_master?.lc_question_type ===
                              'date' || item?.lc_question_type === 'date' ? (
                              <Row gutter={24}>
                                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                                  <FormItem
                                    label="Done Date"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Select From and To date'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <DatePicker
                                      // format={{
                                      //   format: 'YYYY-MM-DD'
                                      // }}
                                      style={{ width: '100%' }}
                                      value={
                                        item?.done_date
                                          ? moment(
                                              item?.done_date,
                                              'YYYY-MM-DD'
                                            )
                                          : item?.done_date
                                      }
                                      onChange={(e) =>
                                        handleChangeDoneDate(
                                          e,
                                          item?.id,
                                          index,
                                          'prod',
                                          'done_date'
                                        )
                                      }
                                      disabled={
                                        isProdRole
                                          ? searchParams.get('id') && !isEdit
                                          : true
                                      }
                                    />
                                  </FormItem>
                                </Col>

                                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                                  <FormItem
                                    label="Due Date"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Select From and To date'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      onChange={(e) =>
                                        handleChangeDoneDate(
                                          e,
                                          item?.id,
                                          index,
                                          'prod',
                                          'due_date'
                                        )
                                      }
                                      value={
                                        item?.due_date
                                          ? moment(item?.due_date, 'YYYY-MM-DD')
                                          : item?.due_date
                                      }
                                      disabled={
                                        isProdRole
                                          ? searchParams.get('id') && !isEdit
                                          : true
                                      }
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                            ) : item?.lc_eqp_question_master
                                ?.lc_question_type === 'date&time' ||
                              item?.lc_question_type === 'date&time' ? (
                              <Row gutter={24}>
                                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                                  <FormItem
                                    label="Done Time"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Select From and To date'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <TimePicker
                                      style={{ width: '100%' }}
                                      onChange={(e) =>
                                        handleChangeDoneDate(
                                          e,
                                          item?.id,
                                          index,
                                          'prod',
                                          'date_time'
                                        )
                                      }
                                      value={
                                        item?.date_time
                                          ? moment(item?.date_time, 'hh:mm')
                                          : item?.date_time
                                      }
                                      disabled={
                                        isProdRole
                                          ? searchParams.get('id') && !isEdit
                                          : true
                                      }
                                    />
                                  </FormItem>
                                </Col>

                                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                                  <FormItem
                                    label="Due Date"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Select From and To date'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      onChange={(e) =>
                                        handleChangeDoneDate(
                                          e,
                                          item?.id,
                                          index,
                                          'prod',
                                          'due_date'
                                        )
                                      }
                                      value={
                                        item?.due_date
                                          ? moment(item?.due_date, 'YYYY-MM-DD')
                                          : item?.due_date
                                      }
                                      disabled={
                                        isProdRole
                                          ? searchParams.get('id') && !isEdit
                                          : true
                                      }
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                            ) : (
                              ''
                            )}
                          </p>
                        </Col>
                        <Col xs={24} xl={6} span={12} md={24} sm={24}>
                          <Radio.Group
                            onChange={(e) =>
                              handleOnChangeProd(
                                item?.id,
                                e.target.value,
                                'prod'
                              )
                            }
                            className={styles.customRadio}
                            value={
                              searchParams.get('id') && !isEdit
                                ? item?.inspect_by_prod
                                : inspectionsByProd?.filter(
                                    (data) => data?.question == item?.id
                                  )?.[0]?.inspect_by_prod
                            }
                            disabled={
                              isProdRole
                                ? searchParams.get('id') && !isEdit
                                : true
                            }
                          >
                            <Radio value="Yes">Yes</Radio>
                            <Radio value="No">No</Radio>
                            <Radio value="NA">NA</Radio>
                          </Radio.Group>
                        </Col>
                        <Col xs={24} xl={6} span={12} md={24} sm={24}>
                          <Radio.Group
                            onChange={(e) =>
                              handleOnChangeProd(item?.id, e.target.value, 'QA')
                            }
                            className={styles.customRadio}
                            name="type"
                            value={
                              item?.inspect_by_qa &&
                              !isEdit &&
                              lCViewData?.qa_sign_date
                                ? item?.inspect_by_qa
                                : inspectionsByQA?.filter(
                                    (data) => data?.question == item?.id
                                  )?.[0]?.inspect_by_qa
                            }
                            disabled={
                              (user?.role == 'qc_initiator'
                                ? lCViewData?.qa_sign_date && !isEdit
                                : true) || qaViewOnly
                            }
                          >
                            <Radio value="Yes">Yes</Radio>
                            <Radio value="No">No</Radio>
                            <Radio value="NA">NA</Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                      {renderOverrideReason(item)}
                      <Divider className={styles.divider} />
                    </>
                  );
                })}
              </Card>
              <Card className={`${styles.cardStyles_approver12}`}>
                <h4>
                  If found satisfactory select Yes; If found Not satisfactory
                  select No; Select NA In case of Not Applicable <br />
                  Note: Refer pictorial display for hard to clean areas during
                  verification
                </h4>
              </Card>
              {lCViewData?.eqp_lc_master?.lc_type === 'ALC' ||
              eqpType === 'ALC' ? (
                <Card className={`${styles.cardStyles_approver12}`}>
                  <Row gutter={24}>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <b>Check Point</b>
                    </Col>
                    <Col xs={24} xl={6} span={6} md={24} sm={24}>
                      <b>Inspected By Production</b>
                    </Col>
                    <Col xs={24} xl={6} span={6} md={24} sm={24}>
                      <b>Inspected By QA</b>
                    </Col>
                  </Row>
                  <Divider className={styles.divider} />
                  {tempLCQtns?.map((item, index) => {
                    return (
                      <>
                        <Row gutter={24} key={index}>
                          <Col xs={24} xl={12} span={12} md={24} sm={24}>
                            <p style={{ color: 'black' }}>
                              {searchParams.get('id')
                                ? item?.lc_eqp_question_master?.lc_eqp_question
                                : item?.lc_eqp_question}
                              <Row gutter={24}>
                                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                                  <FormItem
                                    label="Observed Value"
                                    rules={[
                                      {
                                        required: true,
                                        message: 'Select From and To date'
                                      }
                                    ]}
                                    className={styles.customLable}
                                  >
                                    <Input
                                      placeholder="Enter Observed Value"
                                      onChange={(e) =>
                                        handleChangeDoneDate(
                                          e,
                                          item?.id,
                                          index,
                                          'prod',
                                          'observed_value'
                                        )
                                      }
                                      value={item?.observed_value}
                                      disabled={
                                        isProdRole
                                          ? searchParams.get('id') && !isEdit
                                          : true
                                      }
                                    />
                                  </FormItem>
                                </Col>
                              </Row>
                            </p>
                          </Col>
                          <Col xs={24} xl={6} span={12} md={24} sm={24}>
                            <Radio.Group
                              onChange={(e) =>
                                handleOnChangeProd(
                                  item?.id,
                                  e.target.value,
                                  'prod'
                                )
                              }
                              className={styles.customRadio}
                              value={
                                searchParams.get('id') && !isEdit
                                  ? item?.inspect_by_prod
                                  : inspectionsByProd?.filter(
                                      (data) => data?.question == item?.id
                                    )?.[0]?.inspect_by_prod
                              }
                              disabled={
                                isProdRole
                                  ? searchParams.get('id') && !isEdit
                                  : true
                              }
                            >
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                              <Radio value="NA">NA</Radio>
                            </Radio.Group>
                          </Col>
                          <Col xs={24} xl={6} span={12} md={24} sm={24}>
                            <Radio.Group
                              onChange={(e) =>
                                handleOnChangeProd(
                                  item?.id,
                                  e.target.value,
                                  'QA'
                                )
                              }
                              className={styles.customRadio}
                              name="type"
                              value={
                                item?.inspect_by_qa &&
                                !isEdit &&
                                lCViewData?.qa_sign_date
                                  ? item?.inspect_by_qa
                                  : inspectionsByQA?.filter(
                                      (data) => data?.question == item?.id
                                    )?.[0]?.inspect_by_qa
                              }
                              disabled={
                                (user?.role == 'qc_initiator'
                                  ? lCViewData?.qa_sign_date && !isEdit
                                  : true) || qaViewOnly
                              }
                            >
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                              <Radio value="NA">NA</Radio>
                            </Radio.Group>
                          </Col>
                        </Row>
                        <Divider className={styles.divider} />
                      </>
                    );
                  })}
                </Card>
              ) : (
                ''
              )}
              <Card className={`${styles.cardStyles_approver12}`}>
                <Row gutter={24}>
                  <Col xs={24} xl={8} span={12} md={24} sm={24}>
                    <p style={{ color: 'black' }}>
                      Inference by Production Department
                    </p>
                  </Col>
                  <Col xs={24} xl={16} span={24} md={24} sm={24}>
                    <Space size={100}>
                      <Radio.Group
                        onChange={(e) => handleOnChangeInfProd(e.target.value)}
                        className={styles.customRadio}
                        value={infProd}
                        disabled={
                          isProdRole ? searchParams.get('id') && !isEdit : true
                        }
                      >
                        <Space size={120}>
                          <Radio value="Yes">Equipment Cleared</Radio>
                          <Radio value="No">Not Cleared</Radio>
                          <Radio value="NA">N/A</Radio>
                        </Space>
                      </Radio.Group>
                    </Space>
                  </Col>
                </Row>
                {!isProdRole || lCViewData?.lc_status === 'Approved' ? (
                  <Row gutter={24}>
                    <Col xs={24} xl={8} span={12} md={24} sm={24}>
                      <p style={{ color: 'black' }}>
                        Inference by Quality Assurance Department
                      </p>
                    </Col>

                    <Col xs={24} xl={16} span={24} md={24} sm={24}>
                      <Space size={100}>
                        <Radio.Group
                          onChange={(e) =>
                            handleOnChangeInfProd(e.target.value, 'QA')
                          }
                          className={styles.customRadio}
                          value={infQA}
                          disabled={
                            (user?.role == 'qc_initiator'
                              ? lCViewData?.qa_sign_date && !isEdit
                              : true) || qaViewOnly
                          }
                        >
                          <Space size={120}>
                            <Radio value="Yes">Equipment Cleared</Radio>
                            <Radio value="No">Not Cleared</Radio>
                            <Radio value="NA">N/A</Radio>
                          </Space>
                        </Radio.Group>
                      </Space>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}
                {/* Initiation signatures. Only meaningful on a saved LC, so they are
                    not rendered while creating one. Composed server-side in the same
                    Asia/Kolkata format as sign_date / qa_sign_date below. */}
                {searchParams.get('id') ? (
                  <Row gutter={24}>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="PR Initiated User Id & Date"
                        className={styles.customLable}
                      >
                        <Input
                          value={lCViewData?.pr_initiated_sign || 'NA'}
                          disabled
                        />
                      </FormItem>
                    </Col>
                    {!isProdRole || lCViewData?.lc_status === 'Approved' ? (
                      <Col xs={24} xl={12} span={12} md={24} sm={24}>
                        <FormItem
                          label="QA Verification Initiated User Id & Date"
                          className={styles.customLable}
                        >
                          <Input
                            value={
                              lCViewData?.qa_verification_initiated_sign || 'NA'
                            }
                            disabled
                          />
                        </FormItem>
                      </Col>
                    ) : (
                      ''
                    )}
                  </Row>
                ) : (
                  ''
                )}
                <Row gutter={24}>
                  <Col xs={24} xl={12} span={12} md={24} sm={24}>
                    <FormItem
                      label="PR Submitted User Id & Date"
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Enter Previous Product Name"
                        value={
                          lCViewData?.sign_date
                            ? lCViewData?.sign_date
                            : `${user?.employee} ( ${moment().format(
                                'DD-MM-YYYY'
                              )})`
                        }
                        disabled
                      />
                    </FormItem>
                  </Col>
                  {!isProdRole || lCViewData?.lc_status === 'Approved' ? (
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="QA Approved User Id & Date"
                        className={styles.customLable}
                      >
                        <Input
                          placeholder="Enter Previous Product Name"
                          value={
                            lCViewData?.qa_sign_date
                              ? lCViewData?.qa_sign_date
                              : qaViewOnly
                              ? ''
                              : `${user?.employee} ( ${moment().format(
                                  'DD-MM-YYYY'
                                )})`
                          }
                          disabled
                        />
                      </FormItem>
                    </Col>
                  ) : (
                    ''
                  )}
                </Row>
              </Card>
              {console.log(lCViewData?.eqp_lc_master?.lc_type)}
              {lCViewData?.eqp_lc_master?.lc_type === 'ALC' ||
              eqpType === 'ALC' ? (
                <Card
                  className={`${styles.cardStyles_approver}`}
                  title="Accessories cleaning Verification"
                >
                  <Row gutter={24}>
                    <Col xs={24} xl={4} span={12} md={24} sm={24}>
                      <b>Accessories Name</b>
                    </Col>
                    <Col xs={24} xl={4} span={12} md={24} sm={24}>
                      <b>Accessories ID</b>
                    </Col>
                    <Col xs={24} xl={4} span={12} md={24} sm={24}>
                      <b>Cleaning</b>
                    </Col>
                    <Col xs={24} xl={5} span={6} md={24} sm={24}>
                      <b>Inspected By Production</b>
                    </Col>
                    <Col xs={24} xl={5} span={6} md={24} sm={24}>
                      <b>Inspected By QA</b>
                    </Col>
                    <Col xs={24} xl={2} span={6} md={24} sm={24}></Col>
                  </Row>
                  {allAccessories?.map((item, index) => {
                    return (
                      <Row gutter={24} key={index}>
                        <Col xs={6} xl={4} span={12} md={24} sm={24}>
                          <FormItem
                            rules={[
                              {
                                required: true,
                                message: 'Material Code'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter Accessories Name"
                              onChange={(e) =>
                                handleOnchangeAccessory(
                                  e.target.value,
                                  index,
                                  'accessory_name',
                                  'prod'
                                )
                              }
                              value={item?.accessory_name}
                              disabled={
                                isProdRole
                                  ? searchParams.get('id') && !isEdit
                                  : true
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={6} xl={4} span={12} md={24} sm={24}>
                          <FormItem
                            rules={[
                              {
                                required: true,
                                message: 'Material Code'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Enter Accessories ID"
                              onChange={(e) =>
                                handleOnchangeAccessory(
                                  e.target.value,
                                  index,
                                  'accessory_id',
                                  'prod'
                                )
                              }
                              value={item?.accessory_id}
                              disabled={
                                isProdRole
                                  ? searchParams.get('id') && !isEdit
                                  : true
                              }
                            />
                          </FormItem>
                        </Col>
                        <Col xs={6} xl={4} span={12} md={24} sm={24}>
                          <FormItem
                            rules={[
                              {
                                required: true,
                                message: 'Material Code'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Select
                              placeholder="Select Lineclearance form"
                              onChange={(e) =>
                                handleOnchangeAccessory(
                                  e,
                                  index,
                                  'cleaning',
                                  'prod'
                                )
                              }
                              value={item?.cleaning}
                              disabled={
                                isProdRole
                                  ? searchParams.get('id') && !isEdit
                                  : true
                              }
                            >
                              <option value="satisfactory">Satisfactory</option>
                              <option value="not_satisfactory">
                                Not Satisfactory
                              </option>
                            </Select>
                          </FormItem>
                        </Col>
                        <Col xs={6} xl={5} span={12} md={24} sm={24}>
                          <FormItem
                            rules={[
                              {
                                required: true,
                                message: 'Material Code'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Radio.Group
                              onChange={(e) =>
                                handleOnchangeAccessory(
                                  e.target.value,
                                  index,
                                  'inspect_by_prod',
                                  'prod'
                                )
                              }
                              className={styles.customRadio}
                              value={
                                item?.inspect_by_prod
                                // searchParams.get('id') && !isEdit
                                //   ? item?.inspect_by_prod
                                //   : inspectionsByProd?.filter(
                                //       (data) => data?.question == item?.id
                                //     )?.[0]?.inspect_by_prod
                              }
                              disabled={
                                isProdRole
                                  ? searchParams.get('id') && !isEdit
                                  : true
                              }
                            >
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                              <Radio value="NA">NA</Radio>
                            </Radio.Group>
                          </FormItem>
                        </Col>
                        <Col xs={6} xl={5} span={12} md={24} sm={24}>
                          <FormItem
                            rules={[
                              {
                                required: true,
                                message: 'Material Code'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Radio.Group
                              onChange={(e) =>
                                handleOnchangeAccessory(
                                  e.target.value,
                                  index,
                                  'inspect_by_qa',
                                  'qa'
                                )
                              }
                              className={styles.customRadio}
                              value={
                                item?.inspect_by_qa
                                // &&
                                // !isEdit &&
                                // lCViewData?.qa_sign_date
                                //   ? item?.inspect_by_qa
                                //   : inspectionsByQA?.filter(
                                //       (data) => data?.question == item?.id
                                //     )?.[0]?.inspect_by_qa
                              }
                              disabled={
                                (user?.role == 'qc_initiator'
                                  ? lCViewData?.qa_sign_date && !isEdit
                                  : true) || qaViewOnly
                              }
                            >
                              <Radio value="Yes">Yes</Radio>
                              <Radio value="No">No</Radio>
                              <Radio value="NA">NA</Radio>
                            </Radio.Group>
                          </FormItem>
                        </Col>
                        <Col xs={6} xl={2} span={12} md={24} sm={24}>
                          {isProdRole ? (
                            <FormItem
                              rules={[
                                {
                                  required: true,
                                  message: 'Material Code'
                                }
                              ]}
                              style={{ color: '#c91761', fontSize: '17px' }}
                            >
                              {index === 0 ? (
                                <PlusCircleOutlined
                                  onClick={() => handleAddAccessories()}
                                />
                              ) : (
                                <DeleteOutlined
                                  onClick={(index) =>
                                    handleDeleteAccessories(index)
                                  }
                                />
                              )}
                            </FormItem>
                          ) : (
                            ''
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                </Card>
              ) : (
                ''
              )}
            </>
          ) : (
            ''
          )}
        </Space>
        <br />
        <br />
        {overrideCaptureEnabled && overriddenQuestions().length > 0 ? (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: '16px' }}
            message={`${
              overriddenQuestions().length
            } response(s) differ from the Production response`}
            description="Submitting will override the Production responses to match yours. Each difference needs a reason first."
          />
        ) : null}
        <FormItem className="text-center">
          <Space>
            <CustomButton
              className={styles.inwardButton}
              type="primary"
              ghost
              onClick={() => history.back()}
            >
              Back
            </CustomButton>
            {
              // searchParams.get('id') && isProdRole) ||
              // user?.role === 'qc_initiator' && isEdit ? (
              (searchParams.get('id') &&
                isProdRole &&
                user?.level == 3 &&
                lCViewData?.lc_status !== 'Approved') ||
              // (user?.role === 'qc_initiator' && user?.level == 3) ||
              SuperadminQAdata?.[0]?.level == 2 ||
              SuperadminProddata?.[0]?.level == 3 ? (
                <CustomButton
                  className={styles.inwardButton}
                  htmlType="submit"
                  // onClick={() => handleSubmit('Approved')}
                  type="primary"
                >
                  Update
                </CustomButton>
              ) : lCViewData?.sign_date && lCViewData?.qa_sign_date ? (
                ''
              ) : (
                !(searchParams.get('id') && isProdRole) && (
                  <CustomButton
                    className={styles.inwardButton}
                    htmlType="submit"
                    // onClick={() => handleSubmit('Approved')}
                    type="primary"
                    disabled={
                      (!searchParams.get('id') &&
                        isCompression === true &&
                        !showSubimt) ||
                      qaViewOnly
                    }
                  >
                    Submit
                  </CustomButton>
                )
              )
            }
          </Space>
        </FormItem>
      </Form>

      {openCam ? (
        <QrReader
          constraints={{
            facingMode: 'environment'
          }}
          delay={1000}
          onResult={(result) => handleQrScan(result)}
          style={{
            width: '3px',
            height: '3px'
          }}
        />
      ) : (
        ''
      )}
      {isModal ? (
        <VerificationModal
          isModal={isModal}
          // materials={materials}
          setIsModal={setIsModal}
          material={data}
          // setIsEdit={setIsEdit}
          page={type}
        />
      ) : (
        ''
      )}
      {showQaInitiateModal ? (
        <CustomModal
          title="Initiate LC Verification"
          visible={showQaInitiateModal}
          width="35%"
          footer={null}
          className={styles.customModal}
          closable={false}
          maskClosable={false}
        >
          <p style={{ color: 'black' }}>
            Do you want to initiate LC verification for batch{' '}
            <b>{lCViewData?.current_batch || 'NA'}</b>?
          </p>
          <p style={{ color: '#8c8c8c', fontSize: '13px' }}>
            Choosing Yes records the time verification started and lets you
            complete the QA checklist. Choosing No opens the record in view-only
            mode.
          </p>
          <FormItem className="text-center">
            <Space>
              <CustomButton
                ghost
                type="primary"
                disabled={qaInitiating}
                onClick={() => setShowQaInitiateModal(false)}
              >
                No, just viewing
              </CustomButton>
              <CustomButton
                className={styles.inwardButton}
                type="primary"
                loading={qaInitiating}
                onClick={handleInitiateQaVerification}
              >
                Yes, initiate
              </CustomButton>
            </Space>
          </FormItem>
        </CustomModal>
      ) : (
        ''
      )}
    </Layout>
  );
};
export default LineClearence;
